import { render, staticRenderFns } from "./CropUploader.vue?vue&type=template&id=89ff5bd8&scoped=true&"
import script from "./CropUploader.vue?vue&type=script&lang=js&"
export * from "./CropUploader.vue?vue&type=script&lang=js&"
import style0 from "./CropUploader.vue?vue&type=style&index=0&id=89ff5bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ff5bd8",
  null
  
)

export default component.exports